export default "__VITE_ASSET__DBdhU1Vg__"